<template>
    <span :class="getClass()">
        {{getLabel()}}
    </span>
</template>
<style>

</style>

<script>
    export default {
        props: {
            status: {
                type: Number,
                required: true
            }
        },
        methods: {
            getClass() {
                const self = this;
                switch (self.status) {
                    case 1:
                        return 'badge badge-success';
                    case 2:
                        return 'badge badge-warning';
                    default:
                        return 'badge';
                }
            },
            getLabel() {
                const self = this;
                switch (self.status) {
                    case 1:
                        return 'ACTIVO';
                    case 2:
                        return 'INACTIVO';
                    default:
                        return 'SIN ESTADO';
                }
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/common/StatusBadge.vue